import { PageInfoDto } from '@/dto';
import { FIELDS } from './constants';
import { Dto } from '@/shared/helpers';

export class CompanyInfoDto extends Dto {
  constructor(data = {}) {
    super(FIELDS, data);
  }
}

export let Company = [
  FIELDS.ID,
  FIELDS.GUID,
  FIELDS.PARENT_ID,
  FIELDS.COMPANY_CHANNEL_ID,
  FIELDS.BUSINESS_CHANNEL_ID,
  FIELDS.NUMBER,
  FIELDS.COMPANY_STATUS_ID,
  FIELDS.NAME,
  FIELDS.SHORT_NAME,
  FIELDS.REFERENCE_CODE1,
  FIELDS.REFERENCE_CODE2,
  FIELDS.REFERENCE_CODE3,
  FIELDS.REFERENCE_CODE4,
  FIELDS.REFERENCE_CODE5,
  FIELDS.NUMBERING_PREFIX,
  FIELDS.SCOPE,
  FIELDS.S_SOTYPE,
  FIELDS.WEBSITE,
  FIELDS.LINKEDIN,
  FIELDS.TWITTER,
  FIELDS.FACEBOOK,
  FIELDS.INSTAGRAM,
  FIELDS.TAX_EIN,
  FIELDS.LOGO_URL,
  FIELDS.BUSINESS_ENTITY_TYPE,
  FIELDS.STATE_OF_INCORPORATION,
  FIELDS.IS_VERIFIED,
  FIELDS.IS_DEMO,
  FIELDS.IS_PUBLIC,
  FIELDS.IS_CHANNEL,
  FIELDS.FEE_THRESHOLD,
  FIELDS.NOTES,
  FIELDS.REFERRED_BY_USER_ID,
  FIELDS.DATE_VERIFIED,
  FIELDS.ACTIVE,
  FIELDS.LEGACY,

];

export let dataItem = [
  FIELDS.COMPANY_NAME,
  FIELDS.SHORT_NAME,
  FIELDS.NUMBER,
  FIELDS.NUMBERING_PREFIX,
  FIELDS.SCOPE,
  FIELDS.WEBSITE,
  FIELDS.LINKEDIN,
  FIELDS.TWITTER,
  FIELDS.FACEBOOK,
  FIELDS.INSTAGRAM,
  FIELDS.TAX_EIN,
  FIELDS.BUSINESS_ENTITY_TYPE,
  FIELDS.STATE_OF_INCORPORATION,
  FIELDS.IS_DEMO,
  FIELDS.CHANNEL_NAME,
  FIELDS.ID,
  FIELDS.ACTIVE,
  FIELDS.COMPANY_LOCATION_ID,
  FIELDS.PHYSICAL_ADDRESS1,
  FIELDS.PHYSICAL_ADDRESS2,
  FIELDS.PHYSICAL_CITY,
  FIELDS.PHYSICAL_STATE,
  FIELDS.PHYSICAL_ZIPCODE,
  FIELDS.EMAIL,
  FIELDS.PHONE,
  FIELDS.FAX,
  FIELDS.IS_VERIFIED,
  FIELDS.IS_CHANNEL,
  FIELDS.COMPANY_ROLES_AS_TEXT,
  FIELDS.COMPANY_ROLES_AS_IDS,
  FIELDS.COMPANY_CHANNEL,
  FIELDS.COMPANY_STATUS,
  FIELDS.CONTACT_ID,
  FIELDS.ASP_NET_USER_ID,
  FIELDS.FIRST_NAME,
  FIELDS.LAST_NAME,
  FIELDS.FULL_NAME,
  FIELDS.WORK_TITLE,
  FIELDS.WORK_DEPARTMENT,
  FIELDS.WORK_EMAIL,
  FIELDS.WORK_PHONE1,
  FIELDS.WORK_PHONE1_EXTN,
  FIELDS.WORK_PHONE1_TYPE_ID,
  FIELDS.WORK_FAX,
  FIELDS.PARENT_COMPANY_ID,
  FIELDS.PARENT_COMPANY_SHORT_NAME,
  FIELDS.PARENT_COMPANY_NAME,
  FIELDS.NOTES,
  FIELDS.IS_MAILING_SAME,
  FIELDS.MAILING_ADDRESS1,
  FIELDS.MAILING_ADDRESS2,
  FIELDS.MAILING_CITY,
  FIELDS.MAILING_STATE,
  FIELDS.MAILING_ZIPCODE,
  FIELDS.IS_SHIPPING_SAME,
  FIELDS.SHIPPING_ADDRESS1,
  FIELDS.SHIPPING_ADDRESS2,
  FIELDS.SHIPPING_CITY,
  FIELDS.SHIPPING_STATE,
  FIELDS.SHIPPING_ZIPCODE,

];

export let dataInfo = [
  FIELDS.COMPANY_NAME,
  FIELDS.SHORT_NAME,
  FIELDS.NUMBER,
  FIELDS.NUMBERING_PREFIX,
  FIELDS.SCOPE,
  FIELDS.WEBSITE,
  FIELDS.LINKEDIN,
  FIELDS.TWITTER,
  FIELDS.FACEBOOK,
  FIELDS.INSTAGRAM,
  FIELDS.TAX_EIN,
  FIELDS.BUSINESS_ENTITY_TYPE,
  FIELDS.STATE_OF_INCORPORATION,
  FIELDS.IS_DEMO,
  FIELDS.CHANNEL_NAME,
  FIELDS.ID,
  FIELDS.DATE_CREATED,
  FIELDS.DATE_MODIFIED,
  FIELDS.ACTIVE,
  FIELDS.COMPANY_LOCATION_ID,
  FIELDS.PHYSICAL_ADDRESS1,
  FIELDS.PHYSICAL_ADDRESS2,
  FIELDS.PHYSICAL_CITY,
  FIELDS.PHYSICAL_STATE,
  FIELDS.PHYSICAL_ZIPCODE,
  FIELDS.EMAIL,
  FIELDS.PHONE,
  FIELDS.FAX,
  FIELDS.IS_VERIFIED,
  FIELDS.IS_CHANNEL,
  FIELDS.COMPANY_ROLES_AS_TEXT,
  FIELDS.COMPANY_ROLES_AS_IDS,
  FIELDS.COMPANY_CHANNEL,
  FIELDS.COMPANY_STATUS,
  FIELDS.CONTACT_ID,
  FIELDS.ASP_NET_USER_ID,
  FIELDS.FIRST_NAME,
  FIELDS.LAST_NAME,
  FIELDS.FULL_NAME,
  FIELDS.WORK_TITLE,
  FIELDS.WORK_DEPARTMENT,
  FIELDS.WORK_EMAIL,
  FIELDS.WORK_PHONE1,
  FIELDS.WORK_PHONE1_EXTN,
  FIELDS.WORK_PHONE1_TYPE_ID,
  FIELDS.WORK_FAX,
  FIELDS.PARENT_COMPANY_ID,
  FIELDS.PARENT_COMPANY_SHORT_NAME,
  FIELDS.PARENT_COMPANY_NAME,
  FIELDS.NOTES,
  FIELDS.IS_MAILING_SAME,
  FIELDS.MAILING_ADDRESS1,
  FIELDS.MAILING_ADDRESS2,
  FIELDS.MAILING_CITY,
  FIELDS.MAILING_STATE,
  FIELDS.MAILING_ZIPCODE,
  FIELDS.IS_SHIPPING_SAME,
  FIELDS.SHIPPING_ADDRESS1,
  FIELDS.SHIPPING_ADDRESS2,
  FIELDS.SHIPPING_CITY,
  FIELDS.SHIPPING_STATE,
  FIELDS.SHIPPING_ZIPCODE,

];


export class listDto {
  constructor(results) {
    this.items = results.items.map(item => new gridDto(item));
    this.pageInfo = new PageInfoDto(results.paging);
  }
}

export class CompanyDto {
  constructor(data = {}) {
    Company.forEach(key => (this[key] = data[key] || null));
  }
}

export class dataItemDto {
  constructor(data = {}) {
    dataItem.forEach(key => (this[key] = data[key] || null));
  }
}

export class gridDto {
  constructor(data = {}) {
    dataInfo.forEach(key => (this[key] = data[key] || null));
  }
}
